import { sagaCreator } from '@adrias-online/steiner';
import helper from 'helpers/steinerHelper';

import { actions, actionTypes } from '../actions/cookieConfigAuto';
import { selectors, DEFAULT_STATE } from '../reducers/cookieConfigAuto';
import api from '../apis/cookieConfigAuto';

const sagas = helper.createSagas(
    'cookieConfigAuto',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        numberFilters: ['hotelId']
    }
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
